import React, { useState, useEffect } from "react";

const AIRecommendationSlider = ({
  aiContext = {},
  sequences = [],
  onSequenceSelect = () => {},
}) => {
  const [isOpen, setIsOpen] = useState(true);
  const [matchedSeqs, setMatchedSeqs] = useState([]);

  useEffect(() => {
    if (!aiContext.comments) {
      setMatchedSeqs([]);
      return;
    }

    // Split comments into initials using space, comma, or newline
    const rawTokens = aiContext.comments.split(/[\s,]+/).filter(Boolean);

    const tokens = rawTokens.map((t) => t.toUpperCase()); // normalize

    // Match sequences whose abbreviation or name initials start with any token
    const filtered = sequences.filter((seq) => {
      const seqInitials = seq.name
        .split(/\s+/)
        .map((w) => w[0].toUpperCase())
        .join(""); // take initials of full name

      // Match if any token matches start of seq initials
      return tokens.some((tk) => seqInitials.startsWith(tk));
    });

    setMatchedSeqs(filtered);
  }, [aiContext.comments, sequences]);

  const togglePanel = () => setIsOpen(!isOpen);

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        right: isOpen ? 0 : "-350px",
        width: "27%",
        height: "100%",
        backgroundColor: "#f7f7f7",
        boxShadow: "-2px 0 5px rgba(0,0,0,0.15)",
        transition: "right 0.3s",
        zIndex: 999,
        display: "flex",
        flexDirection: "column",
      }}
    >
      <button
        onClick={togglePanel}
        style={{
          padding: "8px",
          cursor: "pointer",
          backgroundColor: "#007bff",
          color: "white",
          border: "none",
          fontWeight: "bold",
        }}
      >
        {isOpen ? "⏩ Collapse AI Panel" : "⏪ Open AI Panel"}
      </button>

      <div style={{ flex: 1, overflowY: "auto", padding: "12px" }}>
        <h3>AI Panel</h3>

        <div style={{ marginBottom: "12px" }}>
          <strong>Comments:</strong>
          <div
            style={{
              marginTop: "6px",
              padding: "6px",
              backgroundColor: "#fff",
              border: "1px solid #ccc",
              borderRadius: "4px",
              minHeight: "50px",
              whiteSpace: "pre-wrap",
              fontSize: "14px",
            }}
          >
            {aiContext.comments || "(No comments yet)"}
          </div>
        </div>

        <div>
          <strong>Matched Sequences:</strong>
          {matchedSeqs.length === 0 ? (
            <div style={{ marginTop: "6px", fontStyle: "italic", color: "#666" }}>
              No sequences match current comments
            </div>
          ) : (
            matchedSeqs.map((seq) => (
              <div
                key={seq._id}
                style={{
                  padding: "6px 8px",
                  margin: "4px 0",
                  backgroundColor: "#e0f7fa",
                  borderRadius: "4px",
                  cursor: "pointer",
                }}
                onClick={() => onSequenceSelect(seq)}
              >
                {seq.name} ({seq.repetition || ""}x)
              </div>
            ))
          )}
        </div>
      </div>
    </div>
  );
};

export default AIRecommendationSlider;
